import styled from "styled-components";
import FutCircularProgress from "@/components/FutCircularProgress";

export const GlobalWrapper = styled.div`
  padding: 1rem;
  color: white;
`;

export const PageHeader = styled.div`
  width: 100%;
  background: var(--card-bg);
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  padding: 16px;
  margin-bottom: 24px;
  border-radius: 8px 8px 0 0;
`;

export const HeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

export const BackButton = styled.button`
  display: flex;
  align-items: center;
  gap: 8px;
  background: none;
  border: none;
  color: var(--text-color);
  font-size: 14px;
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 4px;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }

  svg {
    font-size: 16px;
  }
`;

export const HomeButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background: rgba(255, 255, 255, 0.15);
  }

  svg {
    font-size: 16px;
    color: var(--text-color);
  }
`;

export const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 600;
  color: var(--text-color);
  margin: 0;
  text-align: center;
  flex: 1;
`;

export const FakeBreadCrumb = styled.div`
  width: 100%;
  margin-bottom: 24px;
`;

export const BreadCrumbCont = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  color: var(--text-color);

  a, span {
    color: var(--text-color);
    text-decoration: none;
  }
`;

export const PlayerCard = styled.div`
  background: rgba(15, 23, 42, 0.8);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
`;

export const PlayerHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.5rem;
  
  img {
    width: 70px;
    height: 70px;
    border-radius: 8px;
    object-fit: cover;
  }
  
  h2 {
    font-size: 1.75rem;
    font-weight: 600;
    margin: 0;
  }
`;

export const PlayerInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
`;

export const InfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
`;

export const InfoLabel = styled.span`
  color: #a1a1aa;
  font-size: 0.875rem;
`;

export const InfoValue = styled.span`
  font-size: 0.95rem;
  font-weight: 500;
`;

export const ClubSection = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

export const ClubLogo = styled.img`
  width: 50px;
  height: 50px;
  object-fit: contain;
`;

export const ClubInfo = styled.div`
  h3 {
    margin: 0;
    font-size: 1rem;
    font-weight: 600;
  }
  
  p {
    margin: 0.25rem 0 0;
    font-size: 0.875rem;
    color: #a1a1aa;
  }
`;

export const AttributesSection = styled.div`
  background: rgba(15, 23, 42, 0.8);
  border-radius: 8px;
  padding: 1.5rem;
  margin: 1rem 0;
  
  h3 {
    margin-top: 0;
    margin-bottom: 1.5rem;
    font-weight: 600;
  }
`;

export const RadarChartContainer = styled.div`
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const AttributesFooter = styled.div`
  text-align: center;
  font-size: 0.875rem;
  color: #a1a1aa;
  margin-top: 1rem;
`;

// Componentes que não são mais usados na nova implementação
export const PlayerProfile = styled.div``;
export const PlayerInfo = styled.div``;
export const TeamContainer = styled.div``;
export const AllInfoPlayer = styled.div``;
export const ContainerPlayerInfo = styled.div``;
export const PlayerInfo01 = styled.div``;
export const PlayerInfoLabel = styled.div``;
export const PlayerDataSection = styled.div``;
export const GridPlayerData = styled.div``;
export const GraphCard = styled.div``;
export const GraphContent = styled.div``;
export const GraphInfo = styled.div``;
export const PenaltiImg = styled.img``;
export const InfoData = styled.div``;
export const StyledCircularFut = styled(FutCircularProgress)``;
